import { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Typography, Button, Stack, Box, IconButton } from '@mui/material';
import Iconify from '../../components/iconify';
import { PATH_SETDEALER } from '../../routes/paths';
// -------------------------------------------------------------------------------------------------------

SetDealerHeader.propTypes = {
    headerName: PropTypes.string,
    franchise: PropTypes.string,
    enabledMonth: PropTypes.string,
    systemSetting: PropTypes.array,
    selectedDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date)
    ]),
};
// -------------------------------------------------------------------------------------------------------
export default function SetDealerHeader({ headerName, selectedDate, franchise, enabledMonth, systemSetting }) {

    const navigate = useNavigate();
    const currentDate = useMemo(() => new Date(), []);
    const currentMonth = currentDate.getMonth();
    const previousMonth = currentMonth === 0 ? 11 : currentMonth - 1;

    const handleDetailsACK = () => {

        navigate(PATH_SETDEALER.dealer.detailsandacknowledgement);

    };

    return (
        <Stack direction='row' alignItems='center' justifyContent='space-between' mb={1} height={56}>
            <Stack direction='column' alignItems='flex-start' justifyContent='flex-start' spacing={1}>
                <Typography variant='h4'>
                    {headerName}
                </Typography>
            </Stack>

            <Box flexGrow={1} />
            <Button variant='contained' onClick={handleDetailsACK }>
                Acknowledge
            </Button>

        </Stack >
    );
}